export const BOOKING_REGISTRATION = 'registration';
export const BOOKING_MANAGE = 'manage';
